module.exports = __webpack_public_path__ + "static/media/burger3.f7a03b99.jpg";